module.exports = __webpack_public_path__ + "img/pic.874d26c3.png";